import React from 'react';
interface SectionTitleProps {
  kicker?: string;
  title: React.ReactNode;
  intro?: string;
  tone?: 'dark' | 'light';
  align?: 'left' | 'center';
}
export function SectionTitle({
  kicker,
  title,
  intro,
  tone = 'dark',
  align = 'left'
}: SectionTitleProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-251" data-mp="4po3kqv8v3ez">
      {kicker && <span className={`inline-block border-[3px] border-noir px-2 py-0.5 font-display text-xs uppercase tracking-[0.14em] ${isDark ? 'bg-jaune text-noir' : 'bg-jaune text-noir'}`} data-id="element-252" data-mp="3m6ff4yi1dc2h">
          {kicker}
        </span>}
      <h2 className={`mt-3 font-display text-3xl uppercase leading-[0.95] md:text-5xl ${isDark ? 'text-noir' : 'text-creme'}`} data-id="element-253" data-mp="3i53xbf5elv4u">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-base leading-relaxed ${isDark ? 'text-noir/70' : 'text-creme/75'}`} data-id="element-254" data-mp="387pghefkj4c0">
          {intro}
        </p>}
    </div>;
}